import { API_URL } from '../constants';
import { apiFetch } from './client';

export interface IAavOrdersQueryParams {
    page?: number;
    limit?: number;
    sortDirection?: 'ASC' | 'DESC';
    statusId?: number | null;
    search?: string;
    tags?: string;
    createdAtMin?: string;
    createdAtMax?: string;
}

export const stringifyAavOrdersParameters = (params: IAavOrdersQueryParams): string => {
    const query: string[] = [];
    try {
        if (params.page) query.push(`page=${params.page}`);
        if (params.limit) query.push(`limit=${params.limit}`);
        if (params.sortDirection) query.push(`sortDirection=${params.sortDirection}`);
        if (params.statusId != null && params.statusId !== 0) query.push(`statusId=${params.statusId}`);
        if (params.search && params.search.length >= 3) query.push(`search=${encodeURIComponent(params.search)}`);
        if (params.tags) query.push(`tags=${encodeURIComponent(params.tags)}`);
        if (params.createdAtMin) query.push(`createdAtMin=${params.createdAtMin}`);
        if (params.createdAtMax) query.push(`createdAtMax=${params.createdAtMax}`);
    } catch (e) {
        console.warn('Error building AAV orders query params');
    }
    return query.join('&');
};

export const getAllAavOrders = async (queryParams: IAavOrdersQueryParams) => {
    const res = await apiFetch(`${API_URL}/aav/orders?${stringifyAavOrdersParameters(queryParams)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};

export const getAavOrderById = async (orderId: number | string) => {
    const res = await apiFetch(`${API_URL}/aav/orders/${orderId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!res.ok) {
        throw new Error('Server Error!');
    }
    return await res.json();
};
